import React, { FC, useState } from 'react';
import { MainTemplate } from '../../components/layouts';
import { DictionaryWrapper } from '../../components/DictionaryWrapper';
import { OrganizationFrFragment, useOrganizationsQuery } from '../../api';
import { Grid, Tooltip } from '@material-ui/core';
import TABLE_OPTIONS from '../../config/tables';
import MUIDataTable, { MUIDataTableColumnDef } from 'mui-datatables';
import { usePermission } from '../../hooks/usePermission';
import { Link, useHistory } from 'react-router-dom';
import { BtnNew } from '../../components/BtnNew';
import { OrganizationsFilter } from '../../components/Filters';

const PER_PAGE = 10;

const Page: FC<{}> = () => {
  const [page, setPage] = useState<number>(0);
  const [filter, setFilter] = useState<any>({
    archive: null,
  });
  const { push } = useHistory();
  const access = usePermission('directory', 'organizations');
  const { data } = useOrganizationsQuery({ variables: { skip: page * PER_PAGE, first: PER_PAGE, filter } });

  const columns: MUIDataTableColumnDef[] = [
    {
      name: 'id',
      label: '',
      options: {
        sort: false,
        display: false,
      },
    },
    {
      name: 'registryNumber',
      label: 'Реестровый номер',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: Pick<OrganizationFrFragment, 'id'>, meta) => {
          return (
            <React.Fragment>
              <Tooltip title="Перейти в карточку" placement="top-start">
                <Link
                  style={{
                    fontWeight: 500,
                    cursor: 'pointer',
                    textDecoration: 'none',
                  }}
                  to={`/organization/${meta.rowData[0]}`}
                >
                  {value}
                </Link>
              </Tooltip>
            </React.Fragment>
          );
        },
      },
    },
    {
      name: 'name',
      label: 'Название',
      options: {
        sort: false,
      },
    },
    {
      name: 'ogrn',
      label: 'ОГРН',
      options: {
        sort: false,
      },
    },
  ];

  return (
    <MainTemplate pageName="Спортивные организации" url="">
      <OrganizationsFilter onSubmit={(filter: any) => setFilter(filter)} />
      <DictionaryWrapper>
        <MUIDataTable
          title={
            <React.Fragment>
              <h2>Спортивные организации</h2>
              <Grid container spacing={1}>
                {access.includes(2) && <Grid item>{<BtnNew onClick={() => push('/organization/new')} />}</Grid>}
              </Grid>
            </React.Fragment>
          }
          data={(data && data.dirOrganizations) || []}
          columns={columns}
          options={{
            ...TABLE_OPTIONS,
            onTableChange: (action, tableState) => {
              switch (action) {
                case 'changePage':
                  setPage(tableState.page);
                  break;
              }
            },
            rowsPerPage: PER_PAGE,
            count: data && data.count,
            page,
          }}
        />
      </DictionaryWrapper>
    </MainTemplate>
  );
};

export default Page;
